import React, { useState, useEffect } from "react";
import { Grid, Button, TextField, Box } from "@material-ui/core";
import * as moment from "moment";
import { useStyles } from "./style";
import withMiddleware from "../../../middleware";
import Table from "../../../components/table";
import Stats from "../../../components/stats/stats";
import { getUserStats, getOrgInvoices } from "../billingHandler";

function BillingHistory(props) {
  const { history, isSuperAdminView = false } = props;
  const classes = useStyles();
  const [invoiceData, setInvoiceData] = useState([]);
  // const [columns, setColumns] = useState([]);
  const [stats, setStats] = useState({
    weeklyActive: 0,
    internal: 0,
    external: 0,
    totalUsers: 0,
  });
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const result = await getUserStats(props.service);
        console.log(result);

        setStats({
          weeklyActive: result.total_active_users ?? 0,
          internal: result.total_internal_users ?? 0,
          external: result.total_external_users ?? 0,
          totalUsers: result.total ?? 0,
          billingFrom: result.billing_from,
          billingTo: result.billing_to,
        });
      } catch (error) {
        console.error("Failed to load billing stats:", error);
      }
    };
    if (!isSuperAdminView) {
      fetchStats();
    }
  }, []);

  useEffect(() => {
    const fetchInvoices = async () => {
      try {
        const invoices = await getOrgInvoices(props.service);
        console.log("invoice for:", invoices);
        setInvoiceData(invoices);
        // setColumns(tableHeader);
      } catch (error) {
        console.error("Failed to load invoices:", error);
      }
    };

    fetchInvoices();
  }, []);

  const handleDownloadInvoice = (rowData) => {
    if (rowData?.pdf_url) {
      const link = document.createElement("a");
      link.href = rowData.pdf_url;
      link.download = `invoice_${rowData.invoice_number || "download"}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.warn("PDF URL not available for:", rowData.billing_email);
    }
  };

  const handlePayNow = (rowData) => {
    if (rowData?.invoice_url) {
      window.open(rowData.invoice_url, "_blank");
    } else {
      console.warn("Invoice URL not available for:", rowData.billing_email);
    }
  };

  const tableHeader = [
    {
      title: "Billing Email",
      field: "billing_email",
    },
    {
      title: "Status",
      field: "status",
      render: (rowData) => {
        const status = rowData?.status?.toLowerCase();
        let background = "#E8F5E9"; // Default green for 'paid'
        let color = "#388E3C";

        if (status === "invoice sent") {
          background = "#FFF3E0"; // Orange
          color = "#F57C00";
        } else if (status === "failed") {
          background = "#FFEBEE"; // Red
          color = "#D32F2F";
        }

        return (
          <span
            style={{
              backgroundColor: background,
              color: color,
              padding: "4px 8px",
              borderRadius: "6px",
              fontSize: 13,
              fontWeight: 500,
              textTransform: "uppercase",
              display: "inline-block",
              minWidth: 70,
              textAlign: "center",
            }}
          >
            {status}
          </span>
        );
      },
    },
    {
      title: "Invoice Number",
      field: "invoice_number",
      render: (rowData) => rowData?.invoice_number ?? "-",
    },
    {
      title: "Invoice Date",
      field: "invoice_date",
      render: (rowData) => moment(rowData?.created_at).format("MMM D, YYYY"),
    },
    {
      title: "Paid at",
      field: "payment_date",
      render: (rowData) => (rowData?.paid_at ? moment(rowData?.paid_at).format("MMM D, YYYY") : "-"),
    },
    // {
    //   title: "Total Users",
    //   field: "total_users",
    //   render: (rowData) => rowData.total_users ?? "-",
    // },
    {
      title: "Amount",
      field: "invoice_amount",
      render: (rowData) => <span style={{ fontWeight: 500 }}>${rowData.amount_due.toFixed(2)}</span>,
    },
    {
      title: "Billing Start",
      field: "billing_period_start",
      render: (rowData) => (rowData?.billing_period_start ? moment(rowData.billing_period_start).format("MMM D, YYYY") : "-"),
    },
    {
      title: "Billing End",
      field: "billing_period_end",
      render: (rowData) => (rowData?.billing_period_end ? moment(rowData.billing_period_end).format("MMM D, YYYY") : "-"),
    },
    {
      title: "Actions",
      field: "actions",
      render: (rowData) => (
        <div>
          {isSuperAdminView ? (
            <Button
              variant="contained"
              color="primary"
              size="small"
              startIcon={<i className="material-icons">save_alt</i>}
              onClick={() => handleDownloadInvoice(rowData)}
            >
              Download
            </Button>
          ) : rowData.status === "paid" ? (
            <Button
              variant="contained"
              color="primary"
              size="small"
              startIcon={<i className="material-icons">save_alt</i>}
              onClick={() => handleDownloadInvoice(rowData)}
            >
              Download
            </Button>
          ) : (
            <Button
              variant="contained"
              color="secondary"
              size="small"
              startIcon={<i className="material-icons">payment</i>}
              onClick={() => handlePayNow(rowData)}
              style={{
                color: "white",
              }}
            >
              Pay Now
            </Button>
          )}
        </div>
      ),
    },
  ];

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  const handleBillingSettings = () => {
    history.push("/org/billing-settings");
  };

  const filteredData = invoiceData.filter((item) => {
    if (!searchTerm) return true;
    return item.billing_email.toLowerCase().includes(searchTerm);
  });

  return (
    <div className={classes.root}>
      <Grid item xs={12} className={classes.table}>
        {!isSuperAdminView ? <Stats stats={stats} /> : null}
        <Grid item xs={12}>
          <Box bgcolor="#fff" borderRadius={12} boxShadow="0 4px 12px rgba(0, 0, 0, 0.08)" p={3} mb={3}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <TextField
                variant="outlined"
                placeholder="Search billing history..."
                size="small"
                onChange={handleSearchChange}
                style={{
                  width: 300,
                  backgroundColor: "#fff",
                }}
                InputProps={{
                  startAdornment: (
                    <i className="material-icons" style={{ marginRight: 8 }}>
                      search
                    </i>
                  ),
                }}
              />
              {!isSuperAdminView ? (
                <Button
                  variant="outlined"
                  color="primary"
                  startIcon={<i className="material-icons">settings</i>}
                  onClick={handleBillingSettings}
                  style={{
                    textTransform: "none",
                    fontWeight: 600,
                    padding: "8px 16px",
                    backgroundColor: "#fff",
                  }}
                >
                  Billing Settings
                </Button>
              ) : null}
            </Box>
            <Table
              columns={
                isSuperAdminView
                  ? [
                      {
                        title: "Organization",
                        field: "org_name",
                      },
                      ...tableHeader,
                    ]
                  : tableHeader
              }
              data={filteredData}
              options={{
                search: false,
                toolbar: false,
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </div>
  );
}

export default withMiddleware(BillingHistory);
